let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c5rFF")).then(() => parcelRequire('6lj4W'));